const CLOSED_TRANSLATE_Y = '12px';
const OPEN_TRANSLATE_DELAY = '0.1s';
const CLOSE_TRANSLATE_DELAY = '0s';

export const listingFilterAccordionMethods = {
    getListingFilterAccordionToggle(container) {
        return (
            container?.querySelector(
                ':scope > .listing__filter-row [data-listing-filter-toggle]'
            ) ||
            container?.querySelector(
                ':scope > .listing__filter-group-header [data-listing-filter-toggle]'
            ) ||
            null
        );
    },

    getListingFilterAccordionWrapper(container) {
        return (
            container?.querySelector(
                ':scope > [data-listing-filter-children]'
            ) || null
        );
    },

    getListingFilterAccordionContent(container) {
        return (
            container
                ?.querySelector(':scope > [data-listing-filter-children]')
                ?.querySelector(
                    ':scope > [data-listing-filter-children-content]'
                ) || null
        );
    },

    setListingFilterAccordionExpandedUi(container, expanded) {
        const toggle = this.getListingFilterAccordionToggle(container);
        const icon = toggle?.querySelector('i');

        if (toggle) {
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        icon?.classList.toggle('rotate-180', expanded);
    },

    setListingFilterAccordionClosedState(container) {
        const wrapper = this.getListingFilterAccordionWrapper(container);
        const content = this.getListingFilterAccordionContent(container);

        if (!wrapper || !content) {
            return;
        }

        wrapper.classList.remove('hidden');
        wrapper.style.height = '0px';
        wrapper.style.opacity = '0';
        content.style.transitionDelay = CLOSE_TRANSLATE_DELAY;
        content.style.transform = `translateY(${CLOSED_TRANSLATE_Y})`;
        content.style.translate = `0 ${CLOSED_TRANSLATE_Y}`;
    },

    setListingFilterAccordionOpenedState(container) {
        const wrapper = this.getListingFilterAccordionWrapper(container);
        const content = this.getListingFilterAccordionContent(container);

        if (!wrapper || !content) {
            return;
        }

        wrapper.classList.remove('hidden');
        wrapper.style.height = 'auto';
        wrapper.style.opacity = '1';
        content.style.transitionDelay = OPEN_TRANSLATE_DELAY;
        content.style.transform = 'translateY(0)';
        content.style.translate = '0 0';
    },

    openListingFilterAccordion(container, { animate = true } = {}) {
        const wrapper = this.getListingFilterAccordionWrapper(container);
        const content = this.getListingFilterAccordionContent(container);

        if (!wrapper || !content) {
            return;
        }

        this.setListingFilterAccordionExpandedUi(container, true);

        if (!animate) {
            this.setListingFilterAccordionOpenedState(container);
            return;
        }

        wrapper.classList.remove('hidden');
        wrapper.style.height = '0px';
        wrapper.style.opacity = '0';
        content.style.transitionDelay = CLOSE_TRANSLATE_DELAY;
        content.style.transform = `translateY(${CLOSED_TRANSLATE_Y})`;
        content.style.translate = `0 ${CLOSED_TRANSLATE_Y}`;
        void wrapper.offsetHeight;

        wrapper.style.height = `${content.scrollHeight}px`;
        wrapper.style.opacity = '1';
        content.style.transitionDelay = OPEN_TRANSLATE_DELAY;
        content.style.transform = 'translateY(0)';
        content.style.translate = '0 0';

        const handleTransitionEnd = event => {
            if (event.propertyName !== 'height') {
                return;
            }

            const toggle = this.getListingFilterAccordionToggle(container);
            const isExpanded = toggle?.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                wrapper.style.height = 'auto';
            }

            wrapper.removeEventListener('transitionend', handleTransitionEnd);
        };

        wrapper.addEventListener('transitionend', handleTransitionEnd);
    },

    closeListingFilterAccordion(container, { animate = true } = {}) {
        const wrapper = this.getListingFilterAccordionWrapper(container);
        const content = this.getListingFilterAccordionContent(container);

        if (!wrapper || !content) {
            return;
        }

        this.setListingFilterAccordionExpandedUi(container, false);
        wrapper.classList.remove('hidden');

        if (!animate) {
            this.setListingFilterAccordionClosedState(container);
            return;
        }

        wrapper.style.height = `${content.scrollHeight}px`;
        wrapper.style.opacity = '1';
        content.style.transitionDelay = OPEN_TRANSLATE_DELAY;
        content.style.transform = 'translateY(0)';
        content.style.translate = '0 0';
        void wrapper.offsetHeight;

        wrapper.style.height = '0px';
        wrapper.style.opacity = '0';
        content.style.transitionDelay = CLOSE_TRANSLATE_DELAY;
        content.style.transform = `translateY(${CLOSED_TRANSLATE_Y})`;
        content.style.translate = `0 ${CLOSED_TRANSLATE_Y}`;
    },

    toggleListingFilterAccordion(container) {
        const toggle = this.getListingFilterAccordionToggle(container);

        if (!toggle) {
            return;
        }

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            this.closeListingFilterAccordion(container);
            return;
        }

        this.openListingFilterAccordion(container);
    },

    syncListingFilterAccordions(root = this.filtersSidebar?.content) {
        if (!root) {
            return;
        }

        const containers = [];

        if (
            root.matches?.(
                '[data-listing-filter-group], [data-listing-filter-node]'
            )
        ) {
            containers.push(root);
        }

        containers.push(
            ...root.querySelectorAll(
                '[data-listing-filter-group], [data-listing-filter-node]'
            )
        );

        containers.forEach(container => {
            const toggle = this.getListingFilterAccordionToggle(container);
            const wrapper = this.getListingFilterAccordionWrapper(container);
            const content = this.getListingFilterAccordionContent(container);

            if (!toggle || !wrapper || !content) {
                return;
            }

            if (toggle.getAttribute('aria-expanded') === 'true') {
                this.setListingFilterAccordionOpenedState(container);
                return;
            }

            this.setListingFilterAccordionClosedState(container);
        });
    },
};
